import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "5b3b095a-1233-4be9-8336-89172269ed9a"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter5b3b095a12334be9833689172269ed9a(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter5b3b095a12334be9833689172269ed9a footer`}>
      {props["links"] || <Navigation className="LinksBd60e0a6F0fe4c90Bd6eFab1724aa1cc" parentTag={buildClassName("LinksBd60e0a6F0fe4c90Bd6eFab1724aa1cc", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo8807134c8d6743b6Aed0Cde9a1e5f088" parentTag={buildClassName("Logo8807134c8d6743b6Aed0Cde9a1e5f088", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright9812547b93d94f07A5d58419d46eb107" parentTag={buildClassName("Copyright9812547b93d94f07A5d58419d46eb107", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow288d81e9D8a64bc4B7bdEb532fd76778" parentTag={buildClassName("Groupflow288d81e9D8a64bc4B7bdEb532fd76778", parentTag)} {...props} />}
    </footer>
  );
}

// id: "8807134c-8d67-43b6-aed0-cde9a1e5f088"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "5b3b095a-1233-4be9-8336-89172269ed9a"
export function Logo8807134c8d6743b6Aed0Cde9a1e5f088(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo8807134c8d6743b6Aed0Cde9a1e5f088" parentTag={buildClassName("Logo8807134c8d6743b6Aed0Cde9a1e5f088", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "9812547b-93d9-4f07-a5d5-8419d46eb107"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "5b3b095a-1233-4be9-8336-89172269ed9a"
export function Copyright9812547b93d94f07A5d58419d46eb107(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright9812547b93d94f07A5d58419d46eb107" parentTag={buildClassName("Copyright9812547b93d94f07A5d58419d46eb107", parentTag)} {...props} />
  );
}

// id: "bd60e0a6-f0fe-4c90-bd6e-fab1724aa1cc"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "5b3b095a-1233-4be9-8336-89172269ed9a"
export function LinksBd60e0a6F0fe4c90Bd6eFab1724aa1cc(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksBd60e0a6F0fe4c90Bd6eFab1724aa1cc" parentTag={buildClassName("LinksBd60e0a6F0fe4c90Bd6eFab1724aa1cc", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "288d81e9-d8a6-4bc4-b7bd-eb532fd76778"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "5b3b095a-1233-4be9-8336-89172269ed9a"
export function Groupflow288d81e9D8a64bc4B7bdEb532fd76778(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow288d81e9D8a64bc4B7bdEb532fd76778" parentTag={buildClassName("Groupflow288d81e9D8a64bc4B7bdEb532fd76778", parentTag)} {...props} />
  );
}

// id: "271a92f1-1f61-46b5-8d39-b65c6ce7f28a"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "8807134c-8d67-43b6-aed0-cde9a1e5f088"
export const LogoType271a92f11f6146b58d39B65c6ce7f28a = "FOOTER";

// id: "272a67ba-c86d-43b1-93f0-45763a7de56d"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "bd60e0a6-f0fe-4c90-bd6e-fab1724aa1cc"
export const NavMenuSlug272a67baC86d43b193f045763a7de56d = "footer-nav";

// id: "b56eeb17-7ba9-43f8-bf92-a34c9c653084"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "8807134c-8d67-43b6-aed0-cde9a1e5f088"
export const ContentSlugB56eeb177ba943f8Bf92A34c9c653084 = "footer-logo";

const Components = {
  DefaultFooter5b3b095a12334be9833689172269ed9a,
  Logo8807134c8d6743b6Aed0Cde9a1e5f088,
  Copyright9812547b93d94f07A5d58419d46eb107,
  LinksBd60e0a6F0fe4c90Bd6eFab1724aa1cc,
  Groupflow288d81e9D8a64bc4B7bdEb532fd76778,
  LogoType271a92f11f6146b58d39B65c6ce7f28a,
  NavMenuSlug272a67baC86d43b193f045763a7de56d,
  ContentSlugB56eeb177ba943f8Bf92A34c9c653084
}

export default Components;